import IconHouseSolid from '@/assets/icons/font_awesome/house-solid.svg?react';
import { use_slice_user } from '@/hooks/store/use_slices';
import { DTO__workspace } from '@shared/dto/+workspace/workspace_entity/DTO__workspace';

interface Props {
  workspace: DTO__workspace;
}

export const IconWorkspaceDefault = ({ workspace }: Props) => {
  const { user_settings } = use_slice_user(['user_settings']);

  if (workspace._id !== user_settings.default_workspace_id) return <></>;

  return (
    <span className="absolute size-full backdrop-blur-sm backdrop-brightness-50 cursor-pointer flex items-center justify-center">
      <IconHouseSolid className="!w-5 !h-5" />
    </span>
  );
};
